module.exports = __webpack_public_path__ + "img/hacienda-resort-8.b7b31095.jpg";